// extracted by mini-css-extract-plugin
export default {"wrapper":"SmallLoading_wrapper__eCi0U","preloader":"SmallLoading_preloader__eiRf2","upDown":"SmallLoading_upDown__fowg1"};